import { render, staticRenderFns } from "./OrderReceivedModal.vue?vue&type=template&id=23f239c4&"
import script from "./OrderReceivedModal.vue?vue&type=script&lang=js&"
export * from "./OrderReceivedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports